<template>
  <div class="chatRoom" :style="{'height':chatHeight}">
    <div class="hiddenInputTextArea" ref="hiddenInputTextArea" :contenteditable="true"></div>
    <!--聊天记录框-->
    <div class="chatList" :style="{'height':maxHeight+'px','padding-bottom':sessionStatus==0?'30px':'0'}">
      <div ref="chatList" style="height:100%">
        <ul v-if="(serviceStatus==6||serviceStatus==4)">
          <li v-if="item" v-for="(item,index) in chatRecord" :class="util.isNotEmpty(item.customerId)?'chat':'client'">
            <div class="accInfo">
              <p>{{ item.fromName }}</p>
              <p v-if="util.isNotEmpty(item.customerId)">{{ item.customerId }}</p>
              <time>{{ item.receiveTime }}</time>
              <div class="translateCon" v-if="util.isNotEmpty(item.customerId)">
                <el-button @click="translateLangPop(index)" size="mini" type="primary" plain>翻译</el-button>
                <div class="translatePop" v-if="translateForm.isTranslateLangPop==(index+1)">
                  <i>把</i>
                  <div class="item_list">
                    <el-select @change="changeSourceLang" v-model="translateForm.initialLangData[index]" size="mini">
                      <el-option
                        v-for="(item,subSourceIndex) in translateForm.sourceLang"
                        :key="subSourceIndex"
                        :label="item"
                        :value="subSourceIndex">
                      </el-option>
                    </el-select>
                  </div>
                  <i class="width">翻译为</i>
                  <div class="item_list">
                    <el-select @change="changeTargetLang" v-model="translateForm.translateLangData[index]" size="mini">
                      <el-option
                        v-for="(item,subTargetIndex) in translateForm.targetLang"
                        :key="subTargetIndex"
                        :label="item"
                        :value="subTargetIndex">
                      </el-option>
                    </el-select>
                  </div>
                  <el-button @click="submitTranslate(item,index)" type="primary" size="mini">翻译</el-button>
                </div>
              </div>
            </div>
            <div class="accCon">
              <div v-html="item.content" @click="imagesPlus(item.content)"></div>
              <div class="conMargin">{{ translateForm.targetContent[index] }}</div>
            </div>
            <div class="accCon1" v-if="item.messageType==2&&util.isNotEmpty(item.previousQuestion)">
              <p>{{ item.previousQuestion }}</p>
            </div>
            <div class="accCon" v-if="item.messageType==7">
              <p v-if="clientChatInfo.locale=='zh_CN'">对不起，{{ item.fromName }}还不会这个问题，是否转人工服务？<a>点这里转人工客服</a></p>
              <p v-else-if="clientChatInfo.locale=='en_US'">Sorry，this question is difficult for {{ item.fromName }} do
                you want to switch to Staff Service? <a>Click here to switch</a></p>
              <p v-else-if="clientChatInfo.locale=='vi_VN'">Xin lỗi，vấn đề này {{ item.fromName }} không trả lời được,
                quý khách có muốn chuyển sang nhân viên CSKH không? <a>Nhấn vào đây để chuyển</a></p>
            </div>
            <div class="accCon" v-if="item.messageType==8">
              <p v-if="clientChatInfo.locale=='zh_CN'">对不起，这个问题难倒{{ item.fromName }}了，是否给我们留言？<a>点这里留言</a></p>
              <p v-else-if="clientChatInfo.locale=='en_US'">Sorry，this question is difficult for {{ item.fromName }}
                would you please leave us a messenger? <a>Click here to leave</a></p>
              <p v-else-if="clientChatInfo.locale=='vi_VN'">Xin lỗi，vấn đề này {{ item.fromName }} không trả lời được,
                quý khách xin để lại lời dặn cho chúng tôi? <a>Nhấn vào Đây để viết lời dặn</a></p>
            </div>
            <div v-if="item.sessionType==0" class="intelligentCon">
              <p v-if="(item.messageType==1||item.messageType==9)&&item.knowledgeList&&item.knowledgeList.length>0">
                {{
                  clientChatInfo.locale == 'zh_CN' ? '您是否需要以下帮助？点击标题查看。' : clientChatInfo.locale == 'en_US' ? 'You may need those information? Please click the title to view details.' : clientChatInfo.locale == 'vi_VN' ? 'Chào bạn, bạn có cần những giúp đỡ bên dưới? Nhấn vào tiêu đề để tìm hiểu chi tiết.' : ''
                }}
              </p>
              <p v-if="item.messageType==2&&item.knowledgeList&&item.knowledgeList.length>0">
                {{
                  clientChatInfo.locale == 'zh_CN' ? '相关问题：' : clientChatInfo.locale == 'en_US' ? 'Related Questions:' : clientChatInfo.locale == 'vi_VN' ? 'Vấn đề liên quan:' : ''
                }}
              </p>
              <ul v-if="item.knowledgeList&&item.knowledgeList.length>0">
                <li v-for="(intelligent,index) in item.knowledgeList">
                  <div class="accCon"><a>{{ index + 1 }}. {{ intelligent.title }}</a></div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul v-if="serviceStatus==5">
          <li v-if="item" v-for="item in chatRecordSingle" :class="item.fromName!=userInfo.userName?'chat':'client'">
            <div class="accInfo">
              <p>{{ item.fromName }}</p>
              <time>{{ item.receiveTime }}</time>
            </div>
            <div class="accCon">
              <div v-html="item.content"></div>
            </div>
          </li>
        </ul>
      </div>
      <div class="endChat" v-if="sessionStatus==0&&util.isNotEmpty(sessionIds[userToken])?true:false">
        <p>{{ customerInfo.name }}{{ $t('im.chatRoom.offline') }}</p>
      </div>
      <div class="advanceInput" id="advanceInput" v-if="advanceChat&&advanceChat.content">
        <p>{{ advanceChat.content }}</p>
      </div>
    </div>
    <div class="inputBox">
      <div v-if="chatType==0" class="masking">
        <el-button type="primary" @click="goArtificialChat">{{ $t('im.chatRoom.artificialChat') }}</el-button>
      </div>
      <!--表情、添加文件等-->
      <div class="chatImg">
        <div v-if="util.isNotEmpty(userID)" class="chatMasking"></div>
        <ul>
          <li @click="makeFace"><img class="face_img" src="@/assets/IM/face.png"/></li>
          <li>
            <img src="@/assets/IM/picture.png"/>
            <el-upload class="upload-demo" multiple
                       :action="uploadMultiUrl"
                       :headers="{isAjax:true}"
                       :before-upload="addInput"
                       :on-success="imgSuc"
                       :on-error="imgErr">
              <el-button size="small" type="primary">{{ $t('im.upload.uploadTipSuffix') }}</el-button>
            </el-upload>
          </li>
          <li v-if="chatType==1">
            <div class="translatePop input-li">
              <i>把</i>
              <div class="item_list">
                <el-select @change="changeSourceLang" v-model="translateForm.inputInitialLang" size="mini">
                  <el-option
                    v-for="(item,subSourceIndex) in translateForm.sourceLang"
                    :key="subSourceIndex"
                    :label="item"
                    :value="subSourceIndex">
                  </el-option>
                </el-select>
              </div>
              <i class="width">翻译为</i>
              <div class="item_list">
                <el-select @change="changeTargetLang" v-model="translateForm.inputTranslateLang" size="mini">
                  <el-option
                    v-for="(item,subTargetIndex) in translateForm.targetLang"
                    :key="subTargetIndex"
                    :label="item"
                    :value="subTargetIndex">
                  </el-option>
                </el-select>
              </div>
            </div>
          </li>
        </ul>
        <!--表情-->
        <div v-show="showFaceList" class="face_panel">
          <ul>
            <li v-for="(item,index) in faceArr" :key="index">
              <img class="face_inner" @click="choiceFace(item)" :src="item"/>
            </li>
          </ul>
        </div>
      </div>
      <!--输入框-->
      <div class="chatTxt">
        <div v-if="util.isNotEmpty(userID)" class="chatMasking"></div>
        <div class="chat_item">
          <div v-if="service==4" class="inputTextArea"
               ref="translateInputTextArea"
               style="width: 40%"
               :contenteditable="true"
               @input="changeTranslateText"
          ></div>
          <div v-if="service==4" class="translatePic" @click="submitTranslate(-1,-1)">
            <img src="@/assets/IM/translate.png"/>
          </div>
          <Textarea ref="inputArea"
                    :width="service==4?60:100"
                    :canEdit="canEdit"
                    :ctrlEdit="ctrlObj"
                    @getAllContent="getAllContent"
                    @scrollTop="scrollTop">
        </Textarea>
        </div>
        <div class="btn">
          <div class="item">
            <span @click="sendMsg">{{ $t('im.common.send') }}</span>
            <em @click="changeSendCtrl(0)"></em>
          </div>
          <ul v-if="isSendCtrl">
            <li v-for="item in sendCtrl" @click="changeSendCtrl(1,item)"><p>{{ item.val }}</p></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import item from '@/layout/components/Sidebar/Item'

require('@/styles/IM/chatRoom.css')
import Textarea from '@/views/IM/model/textarea.vue'
import Msg from '@/utils/IM/Msg_pb'
import Util from '@/utils/IM/tradeDataUtil'
import imStore from '@/store/modules/im'
import { localRead } from '@/utils/tools'
import BScroll from 'better-scroll'
import apiChatSystem from '@/api/im/chatSystem'

export default {
  name: 'chatRoom',
  components: { Textarea },
  props: ['chatHeight', 'maxHeight', 'clientChatInfo', 'service', 'userToken', 'chatType'],
  data() {
    return {
      util: Util,
      allChat: '', // 群聊
      serveSingle: '', // 私聊
      faceArr: [],//表情包列表
      showFaceList: false,   //是否显示表情包
      canEdit: true,  //输入框是否可输入
      talkContent: '', // 输入的聊天内容
      userInfo: JSON.parse(localRead('sys_userInfo_IM')), //用户信息
      chatRecord: [],//聊天消息列表
      oldChatData: '',
      chatRecordSingle: '',//客服私聊聊天消息列表
      oldChatDataSingle: '',
      scroll: '',//聊天记录是否在最底部
      uploadMultiUrl: process.env.VUE_APP_BASE_API + '/serviceBusiness/api/upload/uploadMulti',  //上传文件文件地址
      pageSizeAll: 20,//客服群聊聊天条数
      msgSeqAll: '',
      pageSizeSingle: 10,//客服私聊聊天条数
      msgSeqSingle: '',
      businessIds: '',//角色code
      userID: this.$route.query.id || '',//监控客服ID
      advanceChat: '',//预输入信息
      translateForm: {
        isTranslateLangPop: -1,
        initialLangID: 'auto',
        initialLangData: [],//初始化语言
        inputInitialLang: '',
        sourceLang: {},//原始语言列表
        translateLangID: 'zh_cn',
        translateLangData: [],//翻译语言
        inputTranslateLang: '',
        targetLang: {},//翻译语言列表
        targetContent: {},//翻译语言内容
        translateInnerText: ''
      },
      sendCtrl: [
        {id :0, ctrlKey: true, val: '按Ctrl+Enter键发送消息，Enter换行' },
        {id :1, ctrlKey: false, val: '按Enter键发送消息，Ctrl+Enter换行' }
      ],
      ctrlObj: {id :1, ctrlKey: false, val: '按Enter键发送消息，Ctrl+Enter换行' },
      isSendCtrl:false
    }
  },
  computed: {
    webSocket: {
      get() {
        return this.$store.state.im.webSockets
      }
    },
    /*客服公聊、用户私聊输入socket聊天信息*/
    chatList: {
      get() {
        return this.$store.state.im.chatData
      }
    },
    /*客服私聊输入socket聊天信息*/
    chatListSingle: {
      get() {
        return this.$store.state.im.chatDataSingle
      }
    },
    /*客服公聊输入socket聊天信息*/
    chatListPublic: {
      get() {
        return this.$store.state.im.chatDataPublic
      }
    },
    /*用户信息*/
    customerInfo: {
      get() {
        return this.clientChatInfo
      }
    },
    serviceStatus: {
      get() {
        return this.service
      }
    },
    sessionIds: {
      get() {
        return this.$store.state.im.sessionId
      }
    },
    sessionStatus: {
      get() {
        return this.$store.state.im.sessionStatus
      }
    },
    advanceChatData: {
      get() {
        return this.$store.state.im.advanceChatData
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      this.scroll.scrollTo(0, this.scroll.maxScrollY) // 滑动到指定元素,设置动画300ms
    })
  },
  methods: {
    /*滚动*/
    initScroll() {
      this.scroll = new BScroll(this.$refs.chatList, {
        click: true,
        mouseWheel: true,
        preventDefault: false,
        scrollbar: {
          fade: true,
          interactive: false // 1.8.0 新增
        }
      })
      this.scroll.on('touchEnd', pos => {
        // 下拉动作
        if (pos.y > 20) {
          this.loadMessage('more')
        }
      })
    },
    /*初始化角色code*/
    initCode() {
      let codeData = []
      for (let i in this.userInfo.businessIdUser) {
        codeData.push(this.userInfo.businessIdUser[i].code)
      }
      this.businessIds = codeData.join(',')
    },
    imagesPlus(obj) {
      let index = obj.indexOf('imageView2/0/w/100/h/100/q/75|imageslim')
      if (index > -1) {
        let data = obj.split('?imageView2/0/w/100/h/100/q/75|imageslim">')
      }
    },
    // 显示表情容器
    makeFace() {
      this.showFaceList = !this.showFaceList
      // 动态生成表情，如果现在没有表情则生成
      let faceArr = []
      for (var i = 1; i <= 75; i++) {
        // 根据表情文件数量决定循环次数，这里为75个表情
        if (i != 37) faceArr.push(`https://static.chwenda.com/source/faceImage/${i}.png`)
      }
      this.faceArr = faceArr;
      this.$refs.hiddenInputTextArea.focus()
    },
    getImgString(src) {
      let imgString = '<img src="' + src + '"/>'
      let string = document.createElement('p')
      string.setAttribute('class', 'inputInsertStyle')
      string.innerHTML = imgString
      return string
    },
    /*选中表情*/
    choiceFace(src) {
      /*let img = document.createElement('img')
      img.src = src
      this.$refs.inputArea.addChild(img)*/
      this.$refs.inputArea.addChild(this.getImgString(src))
      this.showFaceList = false
    },
    // 全局关闭表情容器
    globalClick() {
      document.onclick = e => {
        if (e.target.className != 'face_img' && e.target.className != 'face_panel') {
          this.showFaceList = false
        }
      }
    },
    /*图片成功*/
    imgSuc(data) {
      /*let image = new Image()
      image.src = data.result
      this.$refs.inputArea.addChild(image)*/
      this.$refs.inputArea.addChild(this.getImgString(data.result))
    },
    /*图片上传失败*/
    imgErr(data) {
      this.$message.error(window.$t('im.upload.uploadPicFail'))
    },
    /*检查发送文件格式*/
    addInput(file) {
      if (!this.checkFileType(file)) {
        this.$message(window.$t('im.chatRoom.fileType'))
        return
      }
      if (!this.checkFileSize(file)) {
        this.$message(window.$t('im.chatRoom.picType'))
        return
      }
      this.$refs.hiddenInputTextArea.focus()
      this.canvasDataURL(file)
    },
    /*选择文件大小*/
    checkFileSize(file) {
      var mfileSize = file.size / 1024
      if (mfileSize >= 5 * 1024) {
        return false
      }
      return true
    },
    /*选择文件类型*/
    checkFileType(file) {
      let extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      let AllUpExt = '.bmp|.gif|.jpg|.jpeg|.png|.tif|.tiff|'
      if (AllUpExt.indexOf(extName + '|') == '-1') {
        return false
      }
      return true
    },
    canvasDataURL(file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        let res = e.target.result
        let img = new Image()
        img.src = res
        img.onload = () => {
          this.compress(img)
        }
      }
    },
    // 压缩图片
    compress(img) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let width = img.width
      let height = img.height
      canvas.width = width
      canvas.height = height
      // 铺底色
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, width, height)
      // 进行最小压缩
      let ndata = canvas.toDataURL('image/jpeg', 0.5)
      return ndata
    },
    URLRegular(val) {
      let reg = /((http|ftp|https):\/\/)?[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/g
      //获取需要处理的HTML
      let str = JSON.parse(JSON.stringify(val))
      //正则替换
      str = str.replace(reg, function(a) {
        let extName = a.substring(a.lastIndexOf('.')).toLowerCase()
        let AllUpExt = '.bmp|.gif|.jpg|.jpeg|.png|.tif|.tiff|'
        //如果包含http ，indexOf方法如果包含返回0,所以加上!
        if (AllUpExt.indexOf(extName + '|') == '-1') {
          if (!a.indexOf('http')) {
            return '<a href="' + a + '" target=_blank>' + a + '</a>'
          } else {
            return '<a href="http://' + a + '" target=_blank>' + a + '</a>'
          }
        } else {
          return a
        }
      })
      return str
    },
    getHtmlTxt(val) {
      let arr = JSON.parse(JSON.stringify(val)), style = /style\s*?=\s*?(['"])[\s\S]*?\1/g
      arr = arr.replace(style, '')
      if (arr.includes('<a href')) {
        let reg = /<\/?a.*?>/gi
        arr = arr.replace(reg, '')
      }
      return arr
    },
    /*键盘或鼠标点击发送*/
    getAllContent(val) {
      if (val.index == true && val.keyCode == 13) {//键盘发送
        this.talkContent = this.URLRegular(this.getHtmlTxt(val.val))
        this.sendMsg()
      } else {//鼠标点击发送
        this.talkContent = this.URLRegular(this.getHtmlTxt(val))
      }
    },
    scrollTop() {
      let message = this.$refs.inputArea.$el
      message.scrollTop = message.scrollHeight
    },
    /*@某位成员*/
    assignationMember(obj) {
      let string = document.createElement('a')
      string.style.color = '#0096dc'
      string.href = 'javascript:void(0)'
      string.innerHTML = '@' + obj.displayName + ' '
      this.$refs.inputArea.addChild(string)
    },
    textareaRange() {
      let el = this.$refs.translateInputTextArea.childNodes;
      let rang = document.createRange()
      if (el.length >= 1) rang.selectNodeContents(el[el.length - 1])
      rang.collapse(false)
      let sel = document.getSelection()
      if (sel.anchorOffset != 0) return
      sel.removeAllRanges()
      sel.addRange(rang)
    },
    /*复制内容*/
    copyContent(val, type) {
      let string = document.createElement('p')
      string.setAttribute('class', 'inputInsertStyle')
      string.innerHTML = val
      if (type == 0) {
        this.translateForm.translateInnerText = val
        this.$refs.translateInputTextArea.innerHTML = ''
        this.$refs.translateInputTextArea.appendChild(string)
        this.$refs.translateInputTextArea.focus()
        this.textareaRange()
      } else {
        this.$refs.inputArea.addChild(string, type)
      }
    },
    /*用户私聊socket信息*/
    userSingle(message) {
      let messageData = new Msg.MessageData()
      messageData.setMessagedatatype(Msg.MessageDataType.USER_SINGLE)
      let chatMessage = new Msg.ChatMessage()
      chatMessage.setContent(message)
      chatMessage.setCompanyid(this.customerInfo.companyId)
      chatMessage.setBizcode(this.customerInfo.bizCode)
      chatMessage.setLocale(this.customerInfo.locale)
      chatMessage.setClienttype(Msg.ClientType.PC_CLIENT)
      chatMessage.setSessionid(this.customerInfo.sessionId)
      chatMessage.setFrom(this.userInfo.userToken)
      chatMessage.setFromname(this.userInfo.displayName)
      chatMessage.setFromtype(Msg.UserType.SERVICE_USER)
      chatMessage.setFromaccount(this.userInfo.userName)
      chatMessage.setFrombizcode(this.businessIds)
      chatMessage.setSessiontype(Msg.SessionType.MANUAL)
      messageData.setChatmessage(chatMessage)
      let messageArray = messageData.serializeBinary()
      this.webSocket.send(messageArray)
    },
    /*客服私聊socket信息*/
    serviceSingle(message) {
      let messageData = new Msg.MessageData()
      messageData.setMessagedatatype(Msg.MessageDataType.SERVICE_SINGLE)
      let chatMessage = new Msg.ChatMessage()
      chatMessage.setContent(message)
      chatMessage.setCompanyid(this.userInfo.companyId)
      chatMessage.setFrom(this.userInfo.userToken)
      chatMessage.setFromname(this.userInfo.displayName)
      chatMessage.setFromaccount(this.userInfo.userName)
      chatMessage.setFrombizcode(this.businessIds)
      chatMessage.setTo(this.customerInfo.userToken)
      chatMessage.setToname(this.customerInfo.displayName)
      chatMessage.setToaccount(this.customerInfo.userName)
      chatMessage.setTobizcode(this.customerInfo.businessIds)
      messageData.setChatmessage(chatMessage)
      let messageArray = messageData.serializeBinary()
      this.webSocket.send(messageArray)
    },
    /*客服群聊socket信息*/
    serviceAll(message) {
      let messageData = new Msg.MessageData()
      messageData.setMessagedatatype(Msg.MessageDataType.SERVICE_ALL)
      let chatMessage = new Msg.ChatMessage()
      chatMessage.setContent(message)
      chatMessage.setCompanyid(this.userInfo.companyId)
      chatMessage.setFrom(this.userInfo.userToken)
      chatMessage.setFromname(this.userInfo.displayName)
      chatMessage.setFromaccount(this.userInfo.userName)
      chatMessage.setFrombizcode(this.businessIds)
      messageData.setChatmessage(chatMessage)
      let messageArray = messageData.serializeBinary()
      this.webSocket.send(messageArray)
    },
    /*发送信息*/
    sendMsg() {
      this.showFaceList = false
      if (Util.isEmpty(this.talkContent.replace(/\s/g, '').replace(/&nbsp;/ig, ''))) {
        this.$message(window.$t('im.chatRoom.sendNotNull'))
        return
      } else {
        if (Util.isNotEmpty(this.webSocket)) {
          if (this.serviceStatus == 4) {
            if (Util.isEmpty(this.sessionIds[this.userToken])) {
              this.$message(window.$t('im.chatRoom.notSend'))
              return
            } else {
              this.userSingle(this.talkContent)
            }
          } else if (this.serviceStatus == 5) {
            this.serviceSingle(this.talkContent)
          } else if (this.serviceStatus == 6) {
            this.serviceAll(this.talkContent)
          }
          this.$refs.inputArea.clearInnertext()
          this.talkContent = ''
        }
      }
    },
    changeSendCtrl(type, obj) {
      this.isSendCtrl = !this.isSendCtrl
      if (type == 0) {
        this.ctrlObj = {}
      } else {
        this.ctrlObj = obj
      }
    },
    /*初始化判断当前为什么聊天类型*/
    serviceData() {
      if (this.serviceStatus == 4) {
        if (Util.isNotEmpty(this.sessionIds[this.userToken])) {
          this.getChatMessageList(this.sessionIds[this.userToken])
        } else {
          this.getChatMessageList()
        }
      } else if (this.serviceStatus == 6) {
        this.oldChatData = ''
        this.initServiceAllChatMessageList(this.msgSeqAll)
      } else if (this.serviceStatus == 5) {
        this.oldChatDataSingle = ''
        this.initServiceSingleChatMessageList(this.msgSeqSingle)
      }
    },
    getCheckLang(obj, i) {
      if (this.util.isNotEmpty(obj.customerId)) {
        this.translateForm.initialLangData[i] = this.translateForm.sourceLang.auto
        this.translateForm.translateLangData[i] = this.translateForm.targetLang['zh_cn']
      }
    },
    /*用户私聊聊天记录*/
    getChatMessageList(sessionId) {
      if (Util.isNotEmpty(sessionId)) {
        let data = {
          sessionId: sessionId
        }
        apiChatSystem.queryUserChatMessageList(data).then(res => {
          if (res.code == 0) {
            if (res.result.length > 0) {
              let newData = JSON.parse(JSON.stringify(res.result)), chatData = []
              for (const i in newData) {
                chatData.push({
                  fromName: newData[i].fromName,
                  receiveTime: newData[i].receiveTime,
                  customerId: newData[i].fromCustomerId,
                  content: newData[i].message,
                  sessionId: newData[i].sessionId,
                  messageType: newData[i].messageType,
                  sessionType: newData[i].sessionType,
                  knowledgeList: newData[i].conKnowledgeVos,
                  previousQuestion: newData[i].previousQuestion,
                  locale: newData[i].locale
                })
              }
              this.chatRecord = chatData
              for (const i in this.chatRecord) {
                this.getCheckLang(this.chatRecord[i], i)
              }
            } else {
              this.chatRecord = []
            }
          }
        })
      } else {
        this.chatRecord = []
      }
    },
    /*获取客服群聊数据*/
    getServiceAllChatMessageList(data, val) {
      apiChatSystem.queryCommonServiceChatMessageList(data).then(res => {
        if (res.code == 0) {
          if (res.result.length > 0) {
            let newData = JSON.parse(JSON.stringify(res.result)), chatData = []
            for (const i in newData) {
              chatData.push({
                fromName: newData[i].fromName,
                receiveTime: newData[i].receiveTime,
                customerId: newData[i].fromCustomerId,
                content: newData[i].message,
                sessionId: newData[i].sessionId,
                msgSeq: newData[i].msgSeq
              })
            }
            this.chatRecord = chatData.concat(this.oldChatData)
            this.oldChatData = this.chatRecord
          } else if (val == 'more' && res.result.length == 0) {
            this.chatRecord = this.oldChatData
            this.$message(window.$t('im.chatRoom.noMore'))
          } else {
            this.chatRecord = []
          }
          for (const i in this.chatRecord) {
            this.getCheckLang(this.chatRecord[i], i)
          }
        }
      })
    },
    /*客服群聊聊天记录*/
    initServiceAllChatMessageList(msgSeq, val) {
      let data = {
        companyId: this.userInfo.companyId,
        msgSeq: msgSeq,
        pageSize: this.pageSizeAll
      }
      this.getServiceAllChatMessageList(data, val)
    },
    /*获取客服私聊数据*/
    getServiceSingleChatMessageList(data, val) {
      apiChatSystem.queryPrivateServiceChatMessageList(data).then(res => {
        if (res.code == 0) {
          if (res.result.length > 0) {
            let newData = JSON.parse(JSON.stringify(res.result)), chatData = []
            for (const i in newData) {
              chatData.push({
                fromName: newData[i].fromName,
                receiveTime: newData[i].receiveTime,
                customerId: newData[i].fromCustomerId,
                content: newData[i].message,
                sessionId: newData[i].sessionId,
                msgSeq: newData[i].msgSeq
              })
            }
            this.chatRecordSingle = chatData.concat(this.oldChatDataSingle)
            this.oldChatDataSingle = this.chatRecordSingle
          } else if (val == 'more' && res.result.length == 0) {
            this.chatRecordSingle = this.oldChatDataSingle
            this.$message(window.$t('im.chatRoom.noMore'))
          } else {
            this.chatRecordSingle = []
          }
        }
      })
    },
    /*客服私聊聊天记录*/
    initServiceSingleChatMessageList(msgSeq, val) {
      let data = {
        companyId: this.userInfo.companyId,
        msgSeq: msgSeq,
        pageSize: this.pageSizeSingle,
        userToken: this.userInfo.userToken,
        from: this.customerInfo.userToken
      }
      this.getServiceSingleChatMessageList(data, val)
    },
    /*下拉刷新私聊和公聊聊天记录*/
    loadMessage(val) {
      if (this.serviceStatus == 6) {
        this.initServiceAllChatMessageList(this.chatRecord[0].msgSeq, val)
      } else if (this.serviceStatus == 5) {
        this.initServiceSingleChatMessageList(this.chatRecordSingle[0].msgSeq, val)
      }
    },
    /*接待该用户去人工客服*/
    goArtificialChat() {
      if (Util.isNotEmpty(this.sessionIds[this.userToken])) {
        let data = {
          companyId: this.userInfo.companyId,
          serviceName: this.userInfo.displayName,
          serviceToken: this.userInfo.userToken,
          sessionId: this.sessionIds[this.userToken],
          userToken: this.clientChatInfo.userToken
        }
        let sessionId = this.sessionIds[this.userToken]
        apiChatSystem.connectWaitAssignSession(data).then(res => {
          if (res.code == 0 && res.result == true) {
            imStore.dispatch('setIntelligentSessionId', sessionId)
            this.$router.push({
              path: '/chatSystem/chatSystem/:index',
              query: { label: 'IM' }
            })
          } else {
            this.$message.error(window.$t('im.chatRoom.artificialFail'))
          }
        })
      } else {
        this.$message(window.$t('im.chatRoom.notArtificial'))
      }
    },
    getLanguage() {
      apiChatSystem.translateLang().then(res => {
        if (res.code == 0) {
          if (res.result) {
            this.translateForm.initialLangData[0] = res.result.sourceLang.auto
            this.translateForm.inputInitialLang = res.result.sourceLang.auto
            this.translateForm.sourceLang = res.result.sourceLang
            this.translateForm.translateLangData[0] = res.result.targetLang['zh_cn']
            this.translateForm.inputTranslateLang = res.result.targetLang['zh_cn']
            this.translateForm.targetLang = res.result.targetLang
          }
        }
      })
    },
    translateLangPop(indx) {
      this.translateForm.isTranslateLangPop = this.translateForm.isTranslateLangPop == (indx + 1) ? -1 : (indx + 1)
    },
    changeSourceLang(key) {
      this.translateForm.initialLangID = key
    },
    changeTargetLang(key) {
      this.translateForm.translateLangID = key
    },
    changeTranslateText(val) {
      this.translateForm.translateInnerText = val.target.innerText
    },
    submitTranslate(obj, indx) {
      let text = '', contentReg = /[<^>]+>/g
      if (obj != -1) {
        text = obj.content.replace(contentReg, '')
      } else {
        this.$refs.inputArea.clearInnertext()
        text = this.translateForm.translateInnerText.replace(contentReg, '')
      }
      let data = {
        sourceLang: this.translateForm.initialLangID,
        targetLang: this.translateForm.translateLangID,
        text: text
      }
      apiChatSystem.translateText(data).then(res => {
        if (res.code == 0) {
          this.translateForm.isTranslateLangPop = -1
          if (indx != -1) {
            this.translateForm.targetContent[indx] = res.result
          } else {
            this.copyContent(res.result)
          }
          this.$forceUpdate()
        }else this.$message.error(res.message)
      })
    }
  },
  mounted() {
    this.globalClick()
    this.initScroll()
    this.getLanguage()
    this.initCode()
    this.serviceData()
    this.$nextTick(() => {
      this.scroll.scrollTo(0, this.scroll.maxScrollY) // 滑动到指定元素,设置动画300ms
    })
  },
  watch: {
    chatList: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.serviceStatus == 4) {
          let data = JSON.parse(JSON.stringify(this.chatRecord)), userToken
          if (this.chatType == 0) {
            userToken = 'intelligent'
          } else if (this.chatType == 1) {
            userToken = this.userToken
          }
          let newData = [], datas = newVal[userToken]
          for (const j in datas) {
            if (this.sessionIds[this.userToken] == datas[j].sessionId) {
              newData.push(datas[j])
            }
          }
          this.chatRecord = data.concat(newData)
          for (const i in this.chatRecord) {
            this.getCheckLang(this.chatRecord[i], i)
          }
          this.scroll.scrollTo(0, this.scroll.maxScrollY) // 滑动到指定元素,设置动画300ms
        }
      }
    },
    chatListSingle: {
      deep: true,
      handler(newVal, oldVal) {
        let data = JSON.parse(JSON.stringify(this.chatRecordSingle))
        this.chatRecordSingle = data.concat(newVal)
        this.scroll.scrollTo(0, this.scroll.maxScrollY) // 滑动到指定元素,设置动画300ms
      }
    },
    chatListPublic: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.serviceStatus == 6) {
          let data = JSON.parse(JSON.stringify(this.chatRecord))
          this.chatRecord = data.concat(newVal)
          for (const i in this.chatRecord) {
            this.getCheckLang(this.chatRecord[i], i)
          }
          this.scroll.scrollTo(0, this.scroll.maxScrollY) // 滑动到指定元素,设置动画300ms
        }
      }
    },
    sessionIds: {
      deep: true,
      handler(newVal, oldVal) {
        let newData = [], data = this.advanceChatData[this.userToken]
        if (newVal[this.userToken] != oldVal[this.userToken]) {
          if (data) {
            newData = data.filter(obj => {
              if (obj.sessionId == this.sessionIds[this.userToken]) return obj
            })
          }
          this.advanceChat = newData[newData.length - 1]
        }
        if (this.serviceStatus == 4) {
          if (Util.isNotEmpty(newVal[this.userToken])) {
            this.getChatMessageList(newVal[this.userToken])
          } else {
            this.getChatMessageList()
          }
        }
        this.scroll.scrollTo(0, this.scroll.maxScrollY) // 滑动到指定元素,设置动画300ms
      }
    },
    customerInfo: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.serviceStatus == 5) {
          this.oldChatDataSingle = ''
          this.initServiceSingleChatMessageList(this.msgSeqSingle)
        }
      }
    },
    advanceChatData: {
      deep: true,
      handler(newVal, oldVal) {
        let newData = [], data = newVal[this.userToken]
        if (data) {
          newData = data.filter(obj => {
            if (obj.sessionId == this.sessionIds[this.userToken]) return obj
          })
        }
        this.advanceChat = newData[newData.length - 1]
      }
    }
  }
}
</script>
